export const TRAINING_IS_WORK_JURISDICTIONS = ["California"]

export const determineIfTrainingIsWork = (jurisdiction) =>
  TRAINING_IS_WORK_JURISDICTIONS.includes(jurisdiction)
